import React, {useState, useRef, useCallback, useEffect} from 'react';
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';
import { Link, useHistory } from 'react-router-dom';
import Form, {
  Item,
  Label,
  ButtonItem,
  ButtonOptions,
  RequiredRule,
  EmailRule,
  CompareRule,
  PatternRule,
  StringLengthRule,
  GroupItem, SimpleItem//, SimpleItem
} from 'devextreme-react/form';
import notify from 'devextreme/ui/notify';
//import LoadIndicator from 'devextreme-react/load-indicator';
import {createAccount, generateFingerpint} from '../../api/auth';
import './create-account-form.scss';
//import { passwordRulesLabel } from '../label-data';
import Validator from 'devextreme/ui/validator';
import {CheckBox, TextBox} from "devextreme-react";
import ErrorPopup from "../error-popup/error-popup";
import {faEnvelopeOpenText} from "@fortawesome/free-solid-svg-icons";
import {getPduAgreement, getPolicyUrl} from "../../api/resource";
//import { useLocation } from 'react-router-dom';
import StorageService from "../../services/storage.service";
import {useAuth} from "../../contexts/auth";
import {getPass, validPass} from "../../utils/get-password-rules";
import {FIO_ALLOWED_MESSAGE, FAMILIA_ALLOWED_MESSAGE, IMYA_ALLOWED_MESSAGE, OTCHESTVO_ALLOWED_MESSAGE, FIO_PATTERN, FIO_PATTERN_OPTIONAL} from "../../utils/string.utils";

let formInstance

const CreateAccountForm = () => {
  const captchaSymbols = 6
  const envTat = process.env.REACT_APP_NAME_ENV === 'tatenergosbyt'
  const envRenegy = process.env.REACT_APP_NAME_ENV === 'renergy'
  const envInfo = process.env.REACT_APP_NAME_ENV === 'infoenergo'
  const backrgoundCaptcha = !envTat ? '#FFF4E8' : '#FFFFFF';
  const colCount = 2;
  const history = useHistory();
  //const location = useLocation();
  //const [auth, setAuth] = useState(StorageService.getLocalAuth())
  const { setAuth, setCountDogovors } = useAuth();
  const [loading, setLoading] = useState(false);
  const [confirmPolicy, setConfirmPolicy] = useState(false);
  const [confirmConsent, setConfirmConsent] = useState(false);
  const [passwordMode, setPasswordMode] = useState('password')
  const [passwordConfirmMode, setPasswordConfirmMode] = useState('password')
  const eyeclose = require("./../../assets/eyeclose.svg").default
  const eyeopen = require("./../../assets/eyeopen.svg").default
  const [passwordIcon, setPasswordIcon] = useState(eyeclose)
  const [passwordConfirmIcon, setPasswordConfirmIcon] = useState(eyeclose)
  const [popupErrorVisible, setPopupErrorVisible] = useState(false)
  const [popupErrorText, setPopupErrorText] = useState('')
  const [popupIcon, setPopupIcon] = useState(null)
  const [popupTitle, setPopupTitle] = useState("Ошибка")
  const [popupWidth, setPopupWidth] = useState(500)
  const [popupClassNameColorIcon, setPopupClassNameColorIcon] = useState(null)
  const [viewConfirm, setViewConfirm] = useState('viewConfirmFalse')
  const [policyUrl, setPolicyUrl] = useState(null)
  const [formKey, setFormKey] = useState(0);
  const [fromPhoneAuth, setFromPhoneAuth] = useState(true);
  //const [authSettings, setAuthSettings] = useState({})

  //const [selectedRadioValue, setSelectedRadioValue] = useState(0);
  const [cod, setCod] = useState('')
  const formData = useRef({
    inn: '',
    email: '',
    phone: '',
    last_name: '',
    first_name: '',
    middle_name: ''
  });
  //const dataSourceRadio = [{val:0, name:'E-mail'}, {val:1, name:'Телефон'}];

  const [passwordRulesLabel, setPasswordRulesLabel] = useState('Пароль должен состоять минимум из 8 символов, содержать как минимум одну цифру и 2 заглавные буквы')
  useEffect(() => {
    (async function () {
      try {
        const res = await getPass()
        setPasswordRulesLabel(res)
      } catch (e) {
        notify(e.message, 'error', 5000)
      }
    })()
  }, [])

  // 3. Парсим URL и обновляем formData при загрузке
  useEffect(() => {
    (async function () {
      //setSelectedRadioValue(0)
      setFromPhoneAuth(false)
      window.localStorage.setItem("fromPhoneAuth",'false')
      const hash = window.location.hash;
      const queryIndex = hash.indexOf("?");
      if (queryIndex !== -1) {
        const queryString = hash.substring(queryIndex + 1);
        const params = new URLSearchParams(queryString);
       // Обновляем formData, сохраняя предзаполненные значения, если параметров нет в URL
          formData.current = {
            inn: params.get("inn") || formData.current.inn,
            email: params.get("email") || formData.current.email,
            phone: params.get("phone") || formData.current.phone,
            last_name: params.get("last_name") || formData.current.last_name,
            first_name: params.get("first_name") || formData.current.first_name,
          };
        // 4. Форсируем перерендер формы
        setFormKey((prevKey) => prevKey + 1);
        } else if (history.location.state) {
        const locationState = history.location.state;
        // Обновляем formData, сохраняя предзаполненные значения, если параметров нет в URL
        formData.current = {
          inn: locationState?.inn || formData.current.inn,
          email: locationState?.email || formData.current.email,
          phone: locationState?.phone || formData.current.phone,
          last_name: locationState?.last_name || formData.current.last_name,
          first_name: locationState?.first_name || formData.current.first_name,
          middle_name: locationState?.middle_name || formData.current.middle_name,
        };
        //setSelectedRadioValue(1)
        setFromPhoneAuth(true)
        window.localStorage.setItem("fromPhoneAuth",'true')

      }
      })()
  }, [history.location.state]);

  useEffect(() => {
      if (!!(envTat | envRenegy | envInfo) && !fromPhoneAuth) setTimeout(() =>
          loadCaptchaEnginge(captchaSymbols, backrgoundCaptcha, 'black', 'lower'), 100)
  },[backrgoundCaptcha, fromPhoneAuth, envTat, envRenegy, envInfo])

  useEffect(() => {
    (async function () {
      const res = await getPduAgreement()
      if (res.isOk) {
        setPopupErrorText( res?.result["0"].agreement_text )
      } else {
        notify(res.message, 'error', 2000);
      }
      const resPolicy = await getPolicyUrl()
      if (res.isOk) {
        setPolicyUrl(resPolicy.result)
      } else {
        notify(res.message, 'error', 2000);
      }
    })()
  },[])


  const onSubmit = async (e) => {
    e.preventDefault();
    if (!!(envTat | envRenegy | envInfo) && !fromPhoneAuth)  {
      if (validateCaptcha(cod) !== true) {
        notify('Неверный код', 'error', 2000);
        loadCaptchaEnginge(captchaSymbols, backrgoundCaptcha, 'black', 'lower')
        setCod('')
        return;
      }
      loadCaptchaEnginge(captchaSymbols, backrgoundCaptcha, 'black', 'lower')
      setCod('')
    }


    const { inn, email, password, phone, last_name, first_name, middle_name, confirmed_password } = formData.current;

    setLoading(true);
    const fingerprint = await generateFingerpint();
    const result = await createAccount(null, email, password, phone ? '+7' + phone : '', last_name, first_name, middle_name, confirmed_password, inn, fromPhoneAuth, fingerprint);
    /*const result = {
      "isOk": true,
      "data": {
        "access": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImVhbGVrc2luYUBpbmZvZW5lcmdvLnJ1IiwiaWF0IjoxNzYwOTU0NTU3LCJleHAiOjE3NjA5NTQ4NTcsImF1ZCI6InJ5YXphbi1wZy5pbmZvZW5lcmdvLmxvYyIsImlzcyI6ImF1dGgucnlhemFuLXBnLmluZm9lbmVyZ28ubG9jIn0.iAmlqVURFM49D7hVfsnOy-P5_5hULwQDJuWBOrMYoTI",
        "refresh": "hnacjLr7OkbB0kxzLeOnDkemBJuqxGsVCtDT06Mq6no=",
        "userId": 88,
        "dogovors": 9
      }
    }*/
        setLoading(false);
    if (result.isOk && result.data) {
      notify(result.message, 'success', 5000);
      StorageService.setLocalAuth(fingerprint)
      setAuth(result.data)
      setCountDogovors(result.data.dogovors)
    } else if (result.isOk) {
      notify(result.message, 'success', 5000);
      history.push('/login');
    } else {
      notify(result.message, 'error', 5000);
    }
  }

  const confirmPassword = () =>{
    return formData.current.password
  };

  const passwordEditorOptions = {
    placeholder: 'Пароль',
    mode: passwordMode,
    valueChangeEvent:"keyup",
    onValueChanged:async (e) => {
      const editor = formInstance && formInstance.getEditor('ConfirmPassword');
      if (editor && editor.option('value')) {
        const instance = Validator.getInstance(editor.element());
        instance.validate();
      }

      const editorPassword = formInstance && formInstance.getEditor('password');
      if (editorPassword) {
        const instance = Validator.getInstance(editorPassword.element());
        if (await validPass(e.value, passwordRulesLabel.data)) {
          instance._validationRules[0].isValid = false
        }
        instance.validate();
      }
    },
    buttons: [{
      name: 'password',
      location: 'after',
      options: {
        icon: passwordIcon,
        type: 'default',
        onClick() {
          setPasswordMode(passwordMode === 'text' ? 'password' : 'text');
          setPasswordIcon(passwordIcon === eyeclose ? eyeopen : eyeclose)
        },
      },
    }]
  };

  const phoneEditorOptions = {
    mask: '+7 (YX0) 000-0000',
    maskRules: { X: /[01-9]/, Y: /[9]/ },
    maskInvalidMessage: 'Некорректный номер телефона',
    valueChangeEvent:"keyup"
  };

  const phonecheck = () => {
    const editor = formInstance && formInstance.getEditor('phone');
    if (editor) {
      editor.instance().focus()
      editor.instance().blur()
      const instance = Validator.getInstance(editor.element());
      instance.validate();
  }}

  const confirmedPasswordEditorOptions = {
    placeholder: 'Подтверждение пароля',
    mode: passwordConfirmMode,
    buttons: [{
      name: 'password',
      location: 'after',
      options: {
        icon: passwordConfirmIcon,
        type: 'default',
        onClick() {
          setPasswordConfirmMode(passwordConfirmMode === 'text' ? 'password' : 'text');
          setPasswordConfirmIcon(passwordConfirmIcon === eyeclose ? eyeopen : eyeclose)
        },
      },
    }]
  };

  const onInitialized = (e) => {
    formInstance = e.component;
  }

  /*const innEditorOptions = {
    value: inn,
    format: '#',
    valueChangeEvent:"keyup",
    //mode: 'text',
    //format: '000#',
    onValueChanged: function(e) {
      const editor = formInstance && formInstance.getEditor('inn');
      if (editor) {
        const instance = Validator.getInstance(editor.element());
        if (e.value?.toString().length !== 10 && e.value?.toString().length !== 12){
          instance._validationRules[1].isValid=false
        }
        setViewConfirm(e.value?.toString().length === 12 ? 'viewConfirmTrue':'viewConfirmFalse')
        //setConfirm(e.value?.toString().length !== 12)
        instance.validate();
      }
      setInn(e.value)
      e.value && setInn(parseInt(e.value.toString().slice(0,12)))
    }
  }*/

  const valueChanged = useCallback((e) => {
    setCod(e.value);
  }, []);

  const onContentReady = () => {
    // let fpa = window.localStorage.getItem("fromPhoneAuth") === "true"
    // setSelectedRadioValue(fpa ? 1 : 0)
    // setFromPhoneAuth(fpa) //true/alse
    if (!!(envTat | envRenegy | envInfo) && !fromPhoneAuth) {
      setTimeout(() =>
          loadCaptchaEnginge(captchaSymbols, backrgoundCaptcha, 'black', 'lower'), 100)
    }
  }

  const showNotify = async () =>{
    setPopupIcon(faEnvelopeOpenText)
    setPopupTitle('Согласие на обработку персональных данных')
    setPopupClassNameColorIcon('main-color-light')
    setPopupWidth(700)
    setPopupErrorVisible(true)
  }

  return (<>
    <form className={'create-account-form'} onSubmit={onSubmit}>
      <Form key={formKey} // 5. Ключ для принудительного обновления
          formData={formData.current}
            onInitialized={onInitialized}
            disabled={loading}
            labelMode="floating"
            labelLocation="left"
            onContentReady={onContentReady}
            minColWidth={200}
            screenByWidth={screenByWidth}
      >
        {/*{authSettings?.smsNotify &&
            <Item
                editorType="dxRadioGroup"
                editorOptions={{
                  items: dataSourceRadio,
                  value: selectedRadioValue,
                  displayExpr: 'name',
                  valueExpr: 'val',
                  layout:'horizontal',
                  onValueChanged:(e) => {
                    setSelectedRadioValue(e.value)
                    setFromPhoneAuth(!!e.value)
                    window.localStorage.setItem("fromPhoneAuth",!!e.value)
                  },
                }}
            >
            </Item>
        }*/}
        {/*{fromPhoneAuth &&
            <GroupItem>
              <SimpleItem>Перед регистрацией необходимо подтвердить телефон</SimpleItem>
              <GroupItem  colCount={colCount} >
                <Item
                    dataField={'phoneConfirmation'}
                    editorType={'dxTextBox'}
                    editorOptions={phoneEditorConfirmationOptions}
                    name="phone"
                >
                  <Label text="Телефон"/>
                  <PatternRule message="Некорректный формат" pattern={/[9]\d{9}$/} />
                  <RequiredRule message="Телефон обязателен" />
                </Item>
                <ButtonItem>
                  <ButtonOptions
                      width={'100%'}
                      type={'default'}
                      disabled={phoneConfirmValid}
                      text={'Получить код'}
                  ></ButtonOptions>
                </ButtonItem>
              </GroupItem>
            </GroupItem>
        }*/}

          <GroupItem>
            <GroupItem  colCount={colCount} >
            {
                <Item dataField="inn" editorType="dxTextBox" editorOptions={{
                  inputAttr: { maxLength: 12, pattern: '\\d*' }, // Ограничение длины ввода до 20 символов
                  format: '#',
                  valueChangeEvent:"keyup",
                  onInput: (e) => {
                    // Оставляем только цифры в поле ввода
                    e.event.target.value = e.event.target.value.replace(/\D/g, '').slice(0,12);
                    const editor = formInstance && formInstance.getEditor('inn');
                    if (editor) {
                      const instance = Validator.getInstance(editor.element());
                      if (e.event.target.value?.toString().length !== 10 && e.event.target.value?.toString().length !== 12){
                        instance.isValid=false
                        console.log(1)
                      } else {
                        instance.isValid=true
                        console.log(2)
                      }
                      setViewConfirm(e.event.target.value?.toString().length === 12 ? 'viewConfirmTrue':'viewConfirmFalse')
                      //setConfirm(e.value?.toString().length !== 12)
                      instance.validate();
                    }
                    //setInn(e.value)
                    //e.value && setInn(parseInt(e.value.toString().slice(0,12)))
                  },
                  //validationMessagePosition:"top",


                }}>
                  <Label text={"ИНН"} />
                  <RequiredRule message="Введите ИНН. 10 или 12 цифр" />
                  <StringLengthRule validationMessageMode='always' min={10} max={12} message="10 или 12 цифр!" />
                  <PatternRule pattern="^\d{10}(\d{2})?$" message="10 или 12 цифр!" />
                </Item>
            }
            <Item
              dataField={'email'}
              editorType={'dxTextBox'}
              editorOptions={emailEditorOptions}
            >
              <Label text="Email"/>
              {!fromPhoneAuth &&<RequiredRule message="Email обязателен" />}
              <EmailRule message="Email задан неверно" />
            </Item>
            </GroupItem>
            <GroupItem colCount={colCount} >
            <Item
              dataField={'phone'}
              editorType={'dxTextBox'}
              editorOptions={phoneEditorOptions}
              name="phone"
              disabled={!!fromPhoneAuth}
            >
              <Label text="Телефон"/>
              <PatternRule message="Некорректный формат" pattern={/[9]\d{9}$/} />
              {!!fromPhoneAuth &&<RequiredRule message="Телефон обязателен" />}
            </Item>
            <Item
              dataField={'last_name'}
              editorType={'dxTextBox'}
              editorOptions={lastNameEditorOptions}
            >
              <RequiredRule message="Фамилия обязательна" />
              <PatternRule pattern={FIO_PATTERN} message={FAMILIA_ALLOWED_MESSAGE} />
              <Label text="Фамилия" />
            </Item>
            </GroupItem>
            <GroupItem colCount={colCount} >
            <Item
              dataField={'first_name'}
              editorType={'dxTextBox'}
              editorOptions={firstNameEditorOptions}
            >
              <RequiredRule message="Имя обязательно" />
              <PatternRule pattern={FIO_PATTERN} message={IMYA_ALLOWED_MESSAGE} />
              <Label text="Имя" />
            </Item>
            <Item
              dataField={'middle_name'}
              editorType={'dxTextBox'}
              editorOptions={middleNameEditorOptions}
            >
              <PatternRule pattern={FIO_PATTERN_OPTIONAL} message={OTCHESTVO_ALLOWED_MESSAGE} />
              <Label text="Отчество" />
            </Item>
            </GroupItem>
            {!fromPhoneAuth &&
              <GroupItem>
                <GroupItem colCount={colCount} >
                  <Item
                      name='password'
                    dataField={'password'}
                    editorType={'dxTextBox'}
                    editorOptions={passwordEditorOptions}
                  >
                    <PatternRule pattern="^.*$" message={passwordRulesLabel.passTxt} />
                    <StringLengthRule min={8} message={passwordRulesLabel.passTxt} />
                    <RequiredRule message={'Пароль обязателен'} />
                    <Label text="Пароль"/>
                  </Item>
                  <Item
                      name="ConfirmPassword"
                    dataField={'confirmed_password'}
                    editorType={'dxTextBox'}
                    editorOptions={confirmedPasswordEditorOptions}
                  >
                    <RequiredRule message="Подверждение пароля обязательно" />
                    {/*<CustomRule*/}
                    {/*  message={'Пароли не совпадают'}*/}
                    {/*  validationCallback={confirmPassword}*/}
                    {/*/>*/}
                    <CompareRule
                        message="Пароль и подтверждение пароля не совпадают"
                        comparisonTarget={confirmPassword}
                    />
                    <Label text="Подтверждение пароля" />
                  </Item>
                </GroupItem>
                <Item>
                <div className="text">{passwordRulesLabel.passTxt}</div>
                <div className="text">{FIO_ALLOWED_MESSAGE}</div>
                </Item>
              </GroupItem>
            }
            {!envTat &&
                <SimpleItem>
                  <div className="text">Нажимая кнопку "Зарегистрироваться", я
                    <a className="dashed" id="link1" href='/' onClick={(e) => {showNotify(); e.preventDefault()}}> соглашаюсь </a>
                    с обработкой моих персональных данных.&nbsp;<br/>

                    {policyUrl &&
                      <>Ознакомиться с <a href={policyUrl} target={'_blank'} rel={'noopener noreferrer'}>политикой обработки персональных данных</a>.</>
                    }

                  </div>
                </SimpleItem>
            }

            {envTat &&
            <SimpleItem>
              <div className='text tatenergosbyt'>
                <div className="d-flex align-items-start mb-2">
                  <CheckBox className={'mr-2'} value={confirmPolicy} onValueChanged={(e) => setConfirmPolicy(e.value)} />
                  <span>
                    {viewConfirm === 'viewConfirmTrue' &&
                      <>Ознакомлен(а) с <a target='_blank' rel="noreferrer" href='https://tatenergosbyt.ru/about/personal-policy/'>положением об обработке персональных данных</a></>
                    }
                    {viewConfirm === 'viewConfirmFalse' &&
                      <>Ознакомлен(а) с положением об обработке персональных данных</>
                    }
                  </span>
                </div>
                <div className="d-flex align-items-start">
                  <CheckBox className={'mr-2'} value={confirmConsent} onValueChanged={(e) => setConfirmConsent(e.value)} />
                  <span>
                    Даю<a className="dashed" id="link1" href='/' onClick={(e) => {showNotify(); e.preventDefault()}}> согласие на обработку персональных данных</a>
                  </span>
                </div>
              </div>
            </SimpleItem>
            }
            {!!(envTat | envRenegy | envInfo) && !fromPhoneAuth &&
              <GroupItem colCount={colCount} >
                <Item>
                  <div className="captcha">
                    <div className="">
                      <LoadCanvasTemplate reloadText='Обновить' reloadColor='#ED7E31' />
                    </div>
                  </div>
                </Item>
                <Item cssClass={'h-100'}>
                    <div className="captcha-text">
                      <div className="">
                        <TextBox
                            dataField={'kod'}
                            id="user_captcha_input"
                            labelMode='floating'
                            label={'Код с картинки'}
                            onValueChanged={valueChanged}
                            valueChangeEvent="keyup"
                            value={cod}
                        />
                      </div>
                    </div>
                  </Item>
              </GroupItem>
            }
            <ButtonItem>
              <ButtonOptions
                width={'100%'}
                type={'default'}
                useSubmitBehavior={true} onClick={phonecheck}
                disabled={!envTat ? false : !(confirmPolicy && confirmConsent)} text={'Зарегистрироваться'}
              >
                {/*<span className="dx-button-text tatsbyt-text-bold">
                  {
                    loading
                      ? <LoadIndicator width={'24px'} height={'24px'} visible={true} />
                      : 'Зарегистрироваться'
                  }
                </span>*/}
              </ButtonOptions>
            </ButtonItem>
          </GroupItem>

        <Item>
          <div className={'login-link'}>
            Уже есть аккаунт? <Link to={'/login'}>Войти</Link>
          </div>
        </Item>
      </Form>
    </form>
        <ErrorPopup text={popupErrorText}
                    icon = {popupIcon}
                    width={popupWidth}
                    title ={popupTitle}
                    btnVisible={true}
                    visible={popupErrorVisible}
                    onOk={()=>{setPopupErrorVisible(false)}}
                    classNameColorIcon = {popupClassNameColorIcon}
        />
</>
  );
}
function screenByWidth(width) {
  return width < 520 ? 'xs' : 'md';
}
const emailEditorOptions = { mode: 'email' };
const lastNameEditorOptions = {placeholder: 'Фамилия' };
const firstNameEditorOptions = {placeholder: 'Имя' };
const middleNameEditorOptions = { placeholder: 'Отчество' };


export default CreateAccountForm
